export default "__VITE_ASSET__lAgVLSgN__"